import DialogPassengerAgeItem from "./DialogPassengerAgeItem";

export default class DialogPassengerAgeList {
  constructor(_parent,_defaultData = '') {

    this.CL_SHOW = 'isShow';

    this.target = document.createElement('div');
    this.target.classList.add('-age_list');
    const html = `
      <dt>子供の年齢</dt>
      <dd class="-js-agelist"></dd>
    `;
    this.target.innerHTML = html;
    _parent.appendChild(this.target);

    this.insertTarget = this.target.querySelector('.-js-agelist');

    this.ages = [];

    if(_defaultData === '') return;
    const list = _defaultData.split(',');
    list.forEach(age=>{
      this.ages.push(new DialogPassengerAgeItem(this.insertTarget,this.ages.length,age));
    });
    this.updateList();
  }

  updateCount(_count){
    if(this.ages.length > _count){
      this.removeAge();
    } else {
      this.addAge();
    }
  }

  addAge(){
    const age = new DialogPassengerAgeItem(this.insertTarget,this.ages.length);
    this.ages.push(age);
    this.updateList();
  }

  removeAge(){
    const age = this.ages.pop();
    age.onDelete();
    this.updateList();
  }

  onDelete(){
    this.ages.forEach(age=>{
      age.onDelete();
      age = null;
    });
    this.ages = null;

    this.insertTarget = null;
    this.target.remove();
    this.target = null;
    this.parent = null;
  }

  updateList(){
    if(this.ages.length === 0){
      this.target.classList.remove(this.CL_SHOW);
    } else {
      this.target.classList.add(this.CL_SHOW);
    }
  }

  getData(){
    const re = [];
    this.ages.forEach(age=>{
      re.push(age.select.value);
    });
    return re;
  }
}
